import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../../../shared/interfaces/user.interfaces';
import { Observable } from 'rxjs';

const basePath = '/user/authenticate';

@Injectable({
  providedIn: 'root'
})
export class UserAuthenticateService {

  constructor(
    private http: HttpClient
  ) { }

  // Authenticate user with username/email and password
  authenticateUser(usernameOrEmail: string, password: string): Observable<User> {
    return this.http.post<User>(`${basePath}`, { username: usernameOrEmail, password: password })
  }

}
